// ════════════════════════════════════════════════════════════════════════
//  Die Redaktion, damit eine fremde Kennung einen Namen bekommt
//
//  Zwei Stellen brauchen sie: die Fassungsleiste („aus Fassung 13 · angefangen
//  von …“) und die Lehrgangsliste („Entwurf offen von …“). Deshalb liegt sie in
//  `shared/hooks/` und in keinem der beiden Bereiche - wie `useDraftState`.
//
//  Die Liste ändert sich, wenn jemand in die Redaktion aufgenommen wird, und
//  das geschieht von Hand im Dashboard. Sie darf also lange stehen bleiben:
//  eine Stunde, statt der üblichen Minute.
// ════════════════════════════════════════════════════════════════════════

import { useQuery } from "@tanstack/react-query";
import type { OttoClient } from "@otto/plattform";
import type { Person } from "../lib/people.js";

const KEY = ["editorial-people"] as const;

export function useEditorialPeople(client: OttoClient) {
  return useQuery({
    queryKey: KEY,
    staleTime: 60 * 60 * 1000,
    queryFn: async (): Promise<Person[]> => {
      const { data, error } = await client.rpc("editorial_people");
      if (error) throw error;
      // Die Attrappen der Komponententests liefern für jeden Aufruf dasselbe
      // leere Ergebnis; ohne diese Prüfung entstünde daraus eine Person mit
      // `userId: undefined`, die sich wie eine echte läse.
      if (!Array.isArray(data)) return [];
      return data
        .filter(
          (row): row is { user_id: string; label: string } =>
            typeof row === "object" && row !== null && "user_id" in row,
        )
        .map((row) => ({ userId: row.user_id, label: row.label }));
    },
  });
}
